import React from 'react';
import dayjs from 'dayjs';

import { Tooltip } from '@tag/tag-components-react-v4';
import { CheckTickFilled } from '@tag/tag-icons';

import styles from './verification-tooltip-icon.module.scss';

interface IVerificationTooltipIconProps {
  userName: string;
  verifiedAt: string;
  title?: string;
}

export default function VerificationTooltipIcon({
  userName,
  verifiedAt,
  title,
}: IVerificationTooltipIconProps) {
  const formattedDate = dayjs(verifiedAt).format('DD MMM YYYY');

  return (
    <Tooltip
      tooltipFor={
        <span className={styles['verification-icon']}>
          <CheckTickFilled size="14" style={{ fill: '#007373' }} />
        </span>
      }
    >
      <div className={styles['verification-tooltip']}>
        {title && (
          <div className={styles['tooltip-row']}>
            <span className={styles['tooltip-title']}>{title}</span>
          </div>
        )}
        <div className={styles['tooltip-row']}>
          <span className={styles['tooltip-label']}>Verified by:</span>
          <span className={styles['tooltip-value']}>{userName}</span>
        </div>
        <div className={styles['tooltip-row']}>
          <span className={styles['tooltip-label']}>Date:</span>
          <span className={styles['tooltip-value']}>{formattedDate}</span>
        </div>
      </div>
    </Tooltip>
  );
}
